import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import { ERROR_CODES } from '../../constants/errorCodes';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (password.length < 4) {
      setError(ERROR_CODES.RESET_PASSWORD_WEAK);
      return;
    }

    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetchWithAuth('auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });

      let data = {};
      try { data = await response.json(); } catch (_) {}

      if (!response.ok) {
        const code = data.errorCode || 'DEFAULT';
        setError(ERROR_CODES[code] || 'Une erreur est survenue.');
        return;
      }

      setSuccess(true);
    } catch {
      setError('Une erreur est survenue. Réessayez plus tard.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="fixed inset-0 bg-gray-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full text-center">
          <h2 className="text-xl font-bold mb-2">Lien invalide</h2>
          <p className="text-gray-600 mb-4">Ce lien de réinitialisation est invalide ou a expiré.</p>
          <button
            onClick={() => navigate('/')}
            className="bg-black hover:bg-gray-800 text-white px-4 py-2 rounded-md"
          >
            Retour à la connexion
          </button>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="fixed inset-0 bg-gray-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full text-center">
          <h2 className="text-xl font-bold mb-2">Mot de passe réinitialisé</h2>
          <p className="text-gray-600 mb-4">Votre mot de passe a été modifié avec succès.</p>
          <button
            onClick={() => navigate('/')}
            className="bg-black hover:bg-gray-800 text-white px-4 py-2 rounded-md"
          >
            Se connecter
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
        <h2 className="text-xl font-bold mb-2">Nouveau mot de passe</h2>
        <p className="text-gray-600 mb-4">Saisissez votre nouveau mot de passe.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Nouveau mot de passe"
            className="w-full border rounded-md px-3 py-2 mb-3"
            disabled={isLoading}
            autoFocus
          />
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirmer le mot de passe"
            className="w-full border rounded-md px-3 py-2 mb-3"
            disabled={isLoading}
          />

          {error && (
            <div className="text-red-600 text-sm mb-3">{error}</div>
          )}

          <button
            type="submit"
            className="bg-black hover:bg-gray-800 text-white px-4 py-2 rounded-md disabled:opacity-60"
            disabled={isLoading || !password || !confirmPassword}
          >
            {isLoading ? 'Mise à jour…' : 'Valider'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
